/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FONDOCARD} from "../../Constantes";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import {useObtenerAncho} from "../../Modulo_Graficas/Hooks/useObtenerAncho";
import {useContext, useEffect, useRef, useState} from "react";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import {arrConteoColMesesAtrasWheresSuma} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtrasWheresSuma";
import {obtenerGanancias} from "../../CodigoCliente/Ganancias/obtenerGanancias";

const Tarjeta_Activos = () => {
    const cData = useContext(usuarioContext)
    const refe = useRef()
    const {ancho} = useObtenerAncho({contenedor: refe})
    const [totalGanancias, setTotalGanancias] = useState(0)
    const [numContratos, setNumContratos] = useState(0)
    const [rendimientosArr, setRendimientosArr] = useState([])

    useEffect(() => {


        obtenerGanancias(cData.usuario.id).then((dox) => {
            setTotalGanancias(dox)
        })


        let w = [where('idUsuario', '==', cData.usuario.id), where('tipo', 'in', ['Rendimientos', 'Bono']), where('valor', '>', 0)]

        arrConteoColMesesAtrasWheresSuma({
            coleccion: 'movimientos',
            mesesAtras: 12,
            wheres: w,
            propiedad: 'valor'
        }).then((dox) => {
            setRendimientosArr(dox)
          //  console.log(dox)
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...FONDOCARD,
                p: 2,
                color: '#fff',
                minHeight: 170
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Historial Ganancias</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 24,
                            fontWeight: 600
                        }}>{`${formatoMonedaTabla(totalGanancias, 2)} USD`}</Typography>
                    </Grid>


                </Grid>
            </Grid>


            <Grid ref={refe} container size={{xs: 12, sm: 12, md: 7}}
                  sx={{justifyContent: 'flex-start', mt: 2, color: '#000'}}>
                <Linea_Limpia ancho={ancho} labels={rendimientosArr.map((it) => it.nombre)}
                              series={
                                  [{
                                      name: "Ganancias $",
                                      data: rendimientosArr.map((it) => it.cantidad)
                                  }]
                              } marginTop={4} height={150}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Activos
